import PortalIdParser from 'PortalIdParser';
import _get from 'hs-lodash/get';
import { STATUS_CODES } from '../constants/Http';
import { authenticationErrors } from '../constants/errors';
import { actions as errorActions } from '../contexts/error/context';
import { history } from '../utils/general';
import { navigateWithReload } from './helpers';
import { getBaseUrlWithCorrectHublet } from './urls';
const getCallObjectErrorCallback = () => {
  errorActions.setCallObjectOutage(true);
};
const authenticationErrorCallback = ({
  accountsRoute,
  reconnectRoute,
  acceptanceTestBaseRoute,
  response
}) => {
  if (!window.location.pathname.includes(acceptanceTestBaseRoute)) {
    const status = _get(response, 'status');
    const message = _get(response, 'responseJSON.message', '');
    const portalId = PortalIdParser.getPortalIdFromPath();
    if (status === STATUS_CODES.NOT_ACCEPTABLE) {
      const correctHublet = _get(response, 'responseJSON.correctHublet', '');
      navigateWithReload(getBaseUrlWithCorrectHublet(correctHublet));
      return;
    }
    if (status >= STATUS_CODES.INTERNAL_ERROR || status === STATUS_CODES.NETWORKERROR) {
      errorActions.setApiOutage(true);
      return;
    }
    switch (message) {
      case authenticationErrors.noPortalInUrl:
        history.push(accountsRoute);
        break;
      default:
        history.push(`${reconnectRoute}${portalId ? `?portalId=${portalId}` : ''}`);
        break;
    }
  }
};
export default {
  callObject: getCallObjectErrorCallback,
  authentication: authenticationErrorCallback
};